export const SPECS_SCOPE = 'site-search';

export const enum Spec {
  ProductsSorting = 'specs.siteSearch.EnableProductsSorting',
  ShorterSearchTerm = 'specs.siteSearch.EnableShorterSearchTermQuery',
  RenderSeoTags = 'specs.siteSearch.RenderSeoTags',
}
